import React from "react"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"
import { compose } from "redux"
import NotificationAlert from "react-notification-alert"
import * as fire from "firebase"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import { CustomPagination } from "components/Common"
import {
  cancelOrConfirmOrder,
  updateMerchantOrderSlots,
} from "actions/organization/usersActions"

import {
  Badge,
  UncontrolledDropdown,
  Card,
  CardHeader,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Media,
  Table,
  Container,
  Row,
} from "reactstrap"

class Orders extends React.Component {
  state = {
    challenges: [],
    category: [],
    toggleUser: {
      uid: null,
      disabled: false,
    },
    start: 0,
    end: 0,
  }

  _handlePaginationClick(start, end) {
    this.setState({
      start,
      end,
    })
  }

  notify = (type, message, title) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {title}
          </span>
          <span data-notify="message">{message}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    }
    this.refs.notificationAlert.notificationAlert(options)
  }

  _getOrderStatusBadge(order) {
    if (order) {
      if (order.merchantCancelled) return "Cancelled"
      if (order.merchantConfirmed) return "Confirmed"
      if (order.orderPlaced) return "Placed"
    }
  }

  _getOrderPlacementTime(time) {
    // order.time.toDate().getHours() + ':' + order.time.toDate().getMinutes()
    let ret = ""
    if (time) {
      let hours = time.getHours().toString()
      let minutes = time.getMinutes().toString()
      hours = hours.length === 1 ? "0" + hours : hours
      minutes = minutes.length === 1 ? "0" + minutes : minutes
      ret = `${hours}:${minutes}`
      // console.log(ret);
    }
    return ret
  }

  _getUpdateDataForMerchantOrderSlots(order) {
    const data = {}
    if (order) {
      let {
        orderTime,
        orderDuration,
        orderId,
        orderDate,
        orderDateOffset,
      } = order
      const bookedOrderSlots = Math.ceil(orderDuration / 30)
      orderTime = this._get24HourTime(orderTime)
      const startNum = this._getNumFromHour(orderTime)
      const endNum = startNum + bookedOrderSlots / 2
      let slotId = this._getLocalISODateString(
        orderDate.toDate(),
        orderDateOffset
      )
      slotId = slotId.split("T")[0]
      // console.log(startNum, endNum);
      for (let i = startNum; i < endNum; i += 0.5) {
        const slotStart = i
        const slotEnd = i + 0.5
        const startHour = this._getHourFromNum(slotStart)
        const endHour = this._getHourFromNum(slotEnd)
        // console.log('i', i, slotStart, slotEnd, startHour, endHour);
        data[`${slotId}.${startHour}-${endHour}.isBooked`] = false
        data[
          `${slotId}.${startHour}-${endHour}.orderId`
        ] = fire.firestore.FieldValue.arrayRemove(orderId)
      }
    }
    console.log(data)
    return data
  }

  _getLocalISODateString = (date = "", offset = 0) => {
    if (date && typeof offset === "number") {
      return new Date(date.getTime() + -1 * offset * 60 * 1000).toISOString()
    }
    console.log("Issue with date or offset")
    return ""
  }

  _getNumFromHour(time) {
    let num = ""
    if (time) {
      const timeArr = time.split(":")
      let hour = parseInt(timeArr[0])
      let min = parseInt(timeArr[1])
      num = hour
      if (min) {
        num += 0.5
      }
      return num
    }
    return num
  }

  _getHourFromNum(num) {
    let hour = ""
    if (num) {
      const format = (num) => ((num + "").length === 1 ? "0" + num : num)
      if (Number.isInteger(num)) {
        hour = format(num)
        hour += ":00"
      } else {
        hour = format((num + "").split(".")[0])
        hour += ":30"
      }
      return hour
    }
    return hour
  }

  _get24HourTime(time) {
    let newTime = ""
    if (time) {
      const timeArr = time.split(":")
      const hour = parseInt(timeArr[0]),
        min = parseInt(timeArr[1])
      const isAM = time.includes("AM")
      const isPM = time.includes("PM")
      const format = (num) => ((num + "").length === 1 ? "0" + num : num)
      if (hour === 12 && isAM) {
        newTime = `00:${format(min)}` // ToDo: Format Min To Two Digits, If It Is One Digit
      } else if (1 <= hour && hour <= 11 && isAM) {
        newTime = `${format(hour)}:${format(min)}`
      } else if (hour === 12 && isPM) {
        newTime = `${hour}:${format(min)}`
      } else if (1 <= hour && hour <= 11 && isPM) {
        newTime = `${hour + 12}:${format(min)}`
      }
    }
    return newTime
  }

  render() {
    const { orders } = this.props
    const { start, end } = this.state
    return (
      <>
        <SimpleHeader name="Orders" parentName="Orders" />
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        <Container className="mt--6" fluid>
          <Row>
            <div className="col">
              <Card>
                <CardHeader className="border-0">
                  <h3 className="mb-0">Orders</h3>
                </CardHeader>
                <Table className="table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th
                        className="sort"
                        data-sort="name"
                        style={{ width: "130px" }}
                        scope="col"
                      >
                        Customer Details
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Order Summary
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Booking Summary
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Status
                      </th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody className="list">
                    {orders &&
                      orders.length > 0 &&
                      orders.slice(start, end).map((order) => {
                        const orderStatusBadge = this._getOrderStatusBadge(
                          order
                        )
                        const orderStatusColors = {
                          Confirmed: "success",
                          Cancelled: "danger",
                          Placed: "primary",
                        }
                        return (
                          <tr key={order.id}>
                            <th scope="row">
                              <Media className="table-customer-details">
                                <Media>
                                  <span className="mb-0 text-sm text-left">
                                    <b className="h4">{`${order.firstName} ${order.lastName}`}</b>
                                    <br />
                                    <span className="text-muted">
                                      {order.addressLine1 +
                                        ", " +
                                        (order.addressLine2
                                          ? order.addressLine2 + ", "
                                          : "") +
                                        order.city +
                                        ", " +
                                        order.zipCode}
                                    </span>
                                    <br />
                                    <span className="text-muted">
                                      {order.phone}
                                    </span>
                                  </span>
                                </Media>
                              </Media>
                            </th>
                            <td className="table-order-summary">
                              <b>Vehicle Type:</b>{" "}
                              {order.vehicleType.title || ""}
                              <br />
                              <b>Package:</b> {order.package.title || ""}
                              <br />
                              <b>{order.addon.length > 0 && "Addons:"}</b>{" "}
                              {order.addon.map((v) => v.title).join(", ") || ""}
                            </td>
                            <td>
                              <span className="mb-0 text-sm text-left">
                                <i className="fas fa-ticket-alt text-muted"></i>
                                &nbsp; {order.orderId || ""}
                                <br />
                                <i className="fas fa-calendar-alt text-muted"></i>
                                &nbsp;{order.orderDate.toDate().toDateString()}{" "}
                                | <i className="fas fa-clock text-muted"></i>
                                &nbsp;{order.orderTime}
                                <br />
                                <i className="fas fa-stopwatch text-muted"></i>
                                &nbsp;
                                {order.orderDuration
                                  ? Math.floor(order.orderDuration / 60) +
                                    ":" +
                                    (order.orderDuration % 60)
                                  : "-"}{" "}
                                | <i className="fas fa-wallet text-muted"></i>
                                &nbsp;${order.totalCost}
                              </span>
                            </td>
                            <td>
                              {orderStatusBadge ? (
                                <Badge
                                  className="ml-1"
                                  color={
                                    orderStatusColors[orderStatusBadge] || ""
                                  }
                                  pill
                                >
                                  {orderStatusBadge}
                                </Badge>
                              ) : null}
                            </td>
                            <td className="text-right">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  className="btn-icon-only text-light"
                                  color=""
                                  role="button"
                                  size="sm"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>
                                <DropdownMenu
                                  className="dropdown-menu-arrow"
                                  right
                                >
                                  <DropdownItem
                                    disabled={
                                      order.merchantCancelled ||
                                      order.merchantConfirmed
                                    }
                                    onClick={() => {
                                      this.props
                                        .cancelOrConfirmOrder({
                                          status: "confirm",
                                          orderId: order.orderId,
                                        })
                                        .then((isOrderCancelledOrConfirmed) => {
                                          if (isOrderCancelledOrConfirmed) {
                                            this.notify(
                                              "success",
                                              "Order Confirmed!",
                                              "Confirmed"
                                            )
                                          }
                                        })
                                    }}
                                  >
                                    {order.merchantConfirmed
                                      ? "Confirmed Order"
                                      : "Confirm Order"}
                                  </DropdownItem>
                                  <DropdownItem
                                    disabled={order.merchantCancelled}
                                    onClick={() => {
                                      this.props
                                        .cancelOrConfirmOrder({
                                          status: "cancel",
                                          orderId: order.orderId,
                                        })
                                        .then((isOrderCancelledOrConfirmed) => {
                                          if (isOrderCancelledOrConfirmed) {
                                            const updateData = this._getUpdateDataForMerchantOrderSlots(
                                              order
                                            )
                                            this.props.updateMerchantOrderSlots(
                                              {
                                                updateData,
                                                docId: order.merchantId,
                                              }
                                            )
                                            this.notify(
                                              "danger",
                                              "Order Cancelled!",
                                              "Cancelled"
                                            )
                                          }
                                        })
                                    }}
                                  >
                                    {order.merchantCancelled
                                      ? "Cancelled Order"
                                      : "Cancel Order"}
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
                <CustomPagination
                  pageSize={5}
                  dataLen={this.props.orders ? this.props.orders.length : 0}
                  stateCallback={this._handlePaginationClick.bind(this)}
                />
              </Card>
            </div>
          </Row>
        </Container>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    orders: state.firestore.ordered.orders,
    email: state.firebase.auth.email,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    cancelOrConfirmOrder: (data) => dispatch(cancelOrConfirmOrder(data)),
    updateMerchantOrderSlots: (data) =>
      dispatch(updateMerchantOrderSlots(data)),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: `orders`,
      where: ["merchantEmail", "==", props.email],
      storeAs: "orders",
    },
  ])
)(Orders)
